module.exports = __webpack_public_path__ + "img/nodeType4.69ff22d0.svg";